import React from "react";
import { Modal } from "antd";
import CodeEditor2 from "../../../helpers/CodeEditor2";

import { ReactComponent as CloseIcon } from "../../../assets/svg/roundedCloseIcon.svg";

export const FunctionCodePreview = ({ visible, setVisible, srcCode, functionName }: any) => {

  return (
    <Modal
      title={functionName || "FUNCTION CODE PREVIEW"}
      visible={visible}
      className="override-modal function-code-preview"
      closeIcon={
        <CloseIcon
          data-test-id="close_icon"
          height="18px"
          width="18px"
          onClick={() => setVisible(false)}
        />
      }
      footer={false}
      maskStyle={{
        background: "#0000001",
      }}
      onCancel={() => {
        setVisible(false);
        let modalId: number = 7238213;
        let event = new KeyboardEvent("escape", {
          key: "Escape",
          code: "KeyS",
          detail: modalId,
        });
        document.dispatchEvent(event);
      }}
    >
      <CodeEditor2
        functionPreviewModal={visible}
        value={srcCode}
        lang={"javascript"}
        readOnly={true}
        type="inline"
      />
    </Modal>
  )
}
